module.exports = __webpack_public_path__ + "img/map2.e5e79c78.jpg";